import * as I18n from 'circe/I18n';

export const filterVehicleTypes = (vehicleTypes) => vehicleTypes
  .filter((vehicleType) => {
    if (vehicleType.type) {
      return true;
    }

    return false;
  })
  .map((vehicleType) => ({
    value: vehicleType.type,
    label: vehicleType.type,
  }));
